import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'react-query/constant';
import { fetchPatientInfo, fetchPatientShareInfo } from '../services/patient-info-service';
import { usePatientsContext } from 'store/context/patient-context';

const useGetPatientInfo = (id) => {
  const { setUserInfo } = usePatientsContext();
  return useQuery([queryKeys.patientInfo, id], () => fetchPatientInfo(id), {
    refetchOnWindowFocus: false,
    enabled:!!id,
    onSuccess: (data) => {
      setUserInfo(data);
    },
    staleTime: 5 * 60 * 1000, //5min
    cacheTime: 10 * 60 * 1000, //10min
    onError: (error) => console.log(error)
  });
};

const useGetPatientShareInfo = (token) => {
  const { setNativeToken } = usePatientsContext();
  return useQuery(
    [queryKeys.patientShareInfo, token],
    () => fetchPatientShareInfo(token),
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: token?.length > 0,
      onError: (error) => {
        const status = error?.response?.status;
        if (status === 400 || status === 404) setNativeToken(null);
      }
    }
  );
};

export { useGetPatientInfo, useGetPatientShareInfo };
